/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';
import FormattedRelativeWrapper from 'app/components/common/FormattedRelativeWrapper.jsx';
import ConfirmationModal from 'app/components/Subscription/ConfirmationModal.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import * as _ from 'underscore';
import Loading from 'app/components/common/Loading.jsx';
import { Link } from 'react-router-dom';
import { Breakpoint } from 'react-socks';
import AddTweetModal from 'app/components/Subscription/AddTweetModal.jsx';

class UpgradePricing extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            add_on_social: 0,
            add_on_posts_1: 0,
            term: this.props.plans.current.planTerm,
            addOnError: '',
            addOnUpgrade: true,
        };

        this.setAddOns = this.setAddOns.bind(this);
        this.onClickAddOns = this.onClickAddOns.bind(this);
        this.subscriptionUpdate = this.subscriptionUpdate.bind(this);
        this.subscriptionConfirm = this.subscriptionConfirm.bind(this);
        this.addPosts = this.addPosts.bind(this);

    }

    componentDidMount() {

        this.setAddOns(this.props);

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 1, 'option': 'Upgrade'}
                    }
                }
            });
        }

    }

    componentDidUpdate(prevProps, prevState) {

        if ((_.isEmpty(prevProps.plans.current) && !_.isEmpty(this.props.plans.current)) &&
            this.props.plans.current.addOns &&
            this.props.plans.current.addOns != prevProps.plans.current.addOns ||
            !_.isEmpty(this.props.errors)) {
            this.setAddOns(this.props);
        }

    }

    setAddOns(props) {
        let addOns = 0,
            addOnPosting = 0;

        if (props.plans.current.addOns && props.plans.current.addOns.add_on_social) {
            addOns = parseInt(props.plans.current.addOns.add_on_social.qty, 10);
        }
        if (addOns !== this.state.add_on_social) {
            this.setState({
                add_on_social: addOns
            });
        }

        if (props.plans.current.addOns && props.plans.current.addOns.add_on_posts_1) {
            addOnPosting = parseInt(props.plans.current.addOns.add_on_posts_1.qty, 10);
        }
        if (addOnPosting != this.state.add_on_posts_1) {
            this.setState({
                add_on_posts_1: addOnPosting
            });
        }

    }

    onClickAddOns(e) {

        let qty = parseInt(e.currentTarget.dataset.qty, 10),
            nextQty = this.state.add_on_social + qty,
            newLimits = null,
            currentInputs = parseInt(this.props.user.perms.perms.hardLimitInputs, 10) - this.props.user.perms.resources.inputsAvailable,
            currentOutputs = parseInt(this.props.user.perms.perms.hardLimitOutputs, 10) - this.props.user.perms.resources.outputsAvailable,
            addOnUpgrade = this.state.addOnUpgrade,
            constants = this.props.app.config.constants;

        if ((nextQty < this.state.add_on_social)) {
            addOnUpgrade = false;
            newLimits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: nextQty
            }]);
            if ((newLimits.inputs < currentInputs) || (newLimits.outputs < currentOutputs)) {
                this.setState({
                    addOnError: "Your usage would exceed the new limits with fewer add-ons. Turn off or remove feeds and socials to fit the limits."
                });
                return;
            }
        }

        if (nextQty >= 0) {
            this.setState({
                addOnError: '',
                add_on_social: nextQty,
                addOnUpgrade
            });
        }

    }

    subscriptionUpdate(which) {

        if (which === "socials") {
            this.props.onAddOnUpdate({
                add_on_social: this.state.add_on_social
            });
        } else if (which === "posts") {
            this.props.onAddOnUpdate({
                add_on_posts_1: this.state.add_on_posts_1
            });
        }
    }

    subscriptionConfirm(e) {

        let constants = this.props.app.config.constants,
            subscriptionInfo = {
                subscription: this.props.plans.current,
                addOns: {
                    add_on_social: this.state.add_on_social
                }
            },
            addOns = [
                {
                    addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                    quantity: this.state.add_on_social
                }
            ],
            newLimits = {},
            confirmation = null;

        newLimits = this.props.calculateAddOns(addOns);

        confirmation = (
            <ConfirmationModal
                {...this.props}
                confirmationType="addonconfirm"
                confirmationAction={this.subscriptionUpdate}
                subscription={subscriptionInfo}
                newLimits={newLimits}
                addOnType={'socials'}
                planTerm={this.props.plans.current.planTerm} />
        );


        if (mixpanel) {
            let action = "Add-on Upgrade Started";
            if (this.props.plans.current.addOns.add_on_social) {
                if (this.state.add_on_social < this.props.plans.current.addOns.add_on_social.qty) {
                    action = "Add-on Downgrade Started";
                }
            }
            mixpanel.track(action);
        }

        if (gtag) {
            let promoData = this.props.getPersistedData('gaPromo');

            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: (this.state.addOnUpgrade) ? 'Purchase Add-On' : 'Remove Add-On',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: (this.state.addOnUpgrade) ? 'Purchase Add-On' : 'Remove Add-On',
                    event_data: {
                        promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                        promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                    }
                });
            }

        }

        e.preventDefault();

        this.props.addModal(confirmation);

    }

    addPosts(nextQuantity) {
        let constants = this.props.app.config.constants,
            subscriptionInfo = {
                subscription: this.props.plans.current,
                addOns: {
                    add_on_posts_1: nextQuantity
                }
            },
            addOns = [
                {
                    addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                    quantity: nextQuantity
                }
            ],
            newLimits = {},
            confirmation = null,
            currentQuantity = 0;

        if (_.isObject(this.props.plans.current.addOns.add_on_posts_1)) {
            currentQuantity = this.props.plans.current.addOns.add_on_posts_1.qty;
        };

        this.setState({
            add_on_posts_1: nextQuantity
        });

        newLimits = this.props.calculateAddOns(addOns);

        confirmation = (
            <ConfirmationModal
                {...this.props}
                confirmationType="addposts"
                confirmationAction={this.subscriptionUpdate}
                subscription={subscriptionInfo}
                newLimits={newLimits}
                addOnType="posts"
                planTerm={this.props.plans.current.planTerm} />
        );


        if (mixpanel) {
            let action = "Add Posts Upgrade Started";
            if (currentQuantity) {
                if (this.state.add_on_posts_1 < currentQuantity) {
                    action = "Add Posts Downgrade Started";
                }
            }
            mixpanel.track(action);
        }

        if (gtag) {
            let promoData = this.props.getPersistedData('gaPromo');

            gtag('event', 'begin_checkout', {
                currency: 'USD',
                value: 1.0,
                items: [{
                    item_id: 'dlvrit_1',
                    item_name: 'dlvr.it premium plan',
                    item_variant: (this.state.add_on_posts_1 > currentQuantity) ? 'Purchase Add-On Posts' : 'Remove Add-On Posts',
                    price: 1.0,
                    quantity: 1,
                    promotion_id: (promoData && promoData.promotion_id) ? (promoData.promotion_id) : '',
                    promotion_name: (promoData && promoData.promotion_name) ? (promoData.promotion_name) : ''
                }],

            });

            if (this.props.recordEvent) {
                this.props.recordEvent({
                    pub_id: this.props.user.detail.id,
                    event_name: (nextQuantity > currentQuantity) ? 'Purchase Add-On Posts' : 'Remove Add-On Posts',
                    event_data: {
                        quantity: nextQuantity
                    }
                });
            }

        }

        this.props.closeOtherModals(confirmation);
    }

    render() {
        let constants = this.props.app.config.constants,
            currentLimits = {},
            limits = this.props.calculateAddOns([{
                addOn: constants.SUBSCRIPTION_ADDON_SOCIALS,
                quantity: this.state.add_on_social
            },
            {
                addOn: constants.SUBSCRIPTION_ADDON_POSTS_1,
                quantity: this.state.add_on_posts_1
            }]),
            termLabel = '',
            termShortLabel = '',
            buttonClass = '',
            buttonAction = this.subscriptionConfirm,
            upgradeAction = null,
            buttonLabel = 'Upgrade',
            termAddOnPrice = null,
            currentSocialAddOns = 0,
            addOnSocials = 0,
            addOnFeeds = 0,
            headerClass = 'current-sub-header',
            legacyPlans = [constants.PUB_LEVEL_3, constants.PUB_LEVEL_4, constants.PUB_LEVEL_5],
            planLabel = '',
            planPriceLabel = '',
            addOnsLabel = ' add-ons',
            trialInfo = null,
            today = new Date(),
            trialEnd = null,
            errorBlock = null,
            newSubscriptionButton = null,
            planPrice = '',
            addOnError = null,
            addOnBlock = null,
            formattedDate = null,
            annualIncentive = null,
            imageUrl = this.props.app.config.assetsUrl + "/" + this.props.app.config.imageUrl,
            savingsPct = 25,
            activeCoupon = null,
            activeCouponBlock = null,
            lastTermClass = 'last-term',
            renewalBlock = null;

        if (_.isEmpty(this.props.plans.current) || _.isEmpty(this.props.plans.details[this.props.user.detail.pubLevel]) || this.props.app.loading.SUB_FETCH) {
            return (
                <Loading />
            );
        }

        currentLimits = this.props.calculateAddOns();

        let couponStart = null,
            couponExpires = null;

        if (this.props.plans.current.coupons !== undefined && this.props.plans.current.coupons.length) {
            activeCouponBlock = [];
            lastTermClass = '';
            for (let i = 0; i < this.props.plans.current.coupons.length; ++i) {
                let lineDiscount = null,
                    coupon = this.props.plans.current.coupons[i],
                    itemClass = '';

                couponStart = moment(coupon.createdAt);
                if (coupon.temporalUnit !== undefined && coupon.temporalAmount !== undefined) {
                    couponExpires = couponStart.add(coupon.temporalAmount, coupon.temporalUnit);
                }

                if (coupon.type === 'fixed') {
                    lineDiscount = `-$${coupon.currencies[0].amount}`;
                } else if (coupon.type === 'percent') {
                    lineDiscount = `-${coupon.percent}%`;
                } else {
                    continue;
                }

                if (i === (this.props.plans.current.coupons.length - 1)) {
                    itemClass = 'last-term';
                }

                activeCouponBlock.push((
                    <li key={coupon.code} className={itemClass}>
                        <div className="line-item-flex-wrapper">
                            <div className="line-item">
                                Promotion
                            </div>
                            <div className="line-resource-count expiration">
                                {(couponExpires) ? (<span>Expires {couponExpires.format("MMM D, YYYY")}</span>) : null}
                            </div>
                        </div>
                        <div className="line-total">
                            {lineDiscount}
                        </div>
                    </li>
                ));
            }
        }

        if (this.props.isProUser()) {
            headerClass += ' pro';
            savingsPct = 28;
        } else if (this.props.isAgencyUser()) {
            headerClass += ' agency';
        } else if (this.props.isPlusUser()) {
            headerClass += ' proplus';
        } else if (this.props.isAgencyPlusUser()) {
            headerClass += ' agencyplus';
        } else if (this.props.isStarterUser()) {
            savingsPct = 18;
        } else if (this.props.isBasicUser()) {
            savingsPct = 17;
        }

        termAddOnPrice = this.props.plans.details[this.props.user.detail.pubLevel].addOnPrices[this.props.plans.current.planTerm];
        if (this.props.plans.current.planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
            termLabel = "Trial";
            termShortLabel = 'trial';
            newSubscriptionButton = (
                <div className="trial-subscription">
                    <button className="btn-flat" onClick={this.props.newSubscription}>
                        Upgrade now for continuous service
                    </button>
                </div>
            );
        } else if (this.props.plans.current.planTerm == constants.SUBSCRIPTION_TERM_MONTHLY) {
            termLabel = "Month";
            termShortLabel = 'mo';
            annualIncentive = (
                <div className="annual-upgrade-cta">
                    <button className="btn-flat" onClick={(e) => {
                        this.props.changeTerm(e, this.props.setRequestParams);
                    }} data-term={this.props.app.config.constants.SUBSCRIPTION_TERM_ANNUAL}>
                        Switch to Annual
                    </button>
                    <div className="svg-wrapper">
                        <object type="image/svg+xml" data={imageUrl + "/misc/arrow-30.svg"} className="svg-arrow"></object>
                    </div>
                    <div className="annual-copy">
                        Save {savingsPct}%
                    </div>
                </div>
            );
        } else {
            termLabel = "Year";
            termShortLabel = 'yr';
        }

        if (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_social && this.props.plans.current.addOns.add_on_social.qty) {
            if (this.props.plans.current.addOns.add_on_social.qty == 1) {
                addOnsLabel = ' add-on';
            }
            planLabel = 'dlvr.it ' + this.props.plans.details[this.props.user.detail.pubLevel].label + ' with ' + this.props.plans.current.addOns.add_on_social.qty + addOnsLabel;
        } else {
            planLabel = 'dlvr.it ' + this.props.plans.details[this.props.user.detail.pubLevel].label;
        }

        if (this.props.plans.details[this.props.user.detail.pubLevel].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS] !== undefined) {
            addOnSocials = this.props.plans.details[this.props.user.detail.pubLevel].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].socials;
            addOnFeeds = this.props.plans.details[this.props.user.detail.pubLevel].addOnQuantity[constants.SUBSCRIPTION_ADDON_SOCIALS].feeds;
        }

        planPriceLabel = (<span><FormattedNumber value={currentLimits.price} style="currency" currency="USD"/> / {termLabel}</span>);

        currentSocialAddOns = (this.props.plans.current.addOns && this.props.plans.current.addOns.add_on_social) ? this.props.plans.current.addOns.add_on_social.qty : 0;
        if (this.state.add_on_social > currentSocialAddOns) {
            buttonLabel = "Expand your plan";
            buttonClass = "btn-flat add-on-button expand";
        } else if (this.state.add_on_social < currentSocialAddOns) {
            buttonLabel = "Reduce your plan";
            buttonClass = "btn-flat add-on-button reduce";
        } else {
            buttonLabel = "You are here";
            buttonClass = "btn-flat add-on-button";
            buttonAction = null;
        }

        if (this.props.plans.current.trialEndsAt) {
            trialEnd = new Date(this.props.plans.current.trialEndsAt);
            formattedDate = moment(this.props.plans.current.trialEndsAt).format();
            if (today <= trialEnd) {
                trialInfo = (
                    <div className="plan-trial-info">
                        <i className="icon ion-ios-information-outline"></i> Your free trial of {planLabel} ends <FormattedRelativeWrapper value={formattedDate}/>
                    </div>
                );
            }
        }

        if (this.props.user && this.props.user.plan.status !== undefined && this.props.user.plan.status.canceled === true) {
            formattedDate = moment(this.props.plans.current.nextBilling).format();
            trialInfo = (
                <div className="plan-trial-info">
                    <i className="icon ion-ios-information-outline"></i> Your {planLabel} subscription ends <FormattedRelativeWrapper value={formattedDate}/>
                </div>
            );
        }

        if (this.props.errors !== null) {
            errorBlock = (
                <div className="subscription-error">
                    We couldn't complete your transaction. Please <Link to="/account/billing?update=true">update your billing information.</Link>
                </div>
            );
        }

        if (this.state.addOnError !== null) {
            addOnError = (
                <div className="subscription-error add-on">
                    {this.state.addOnError}
                </div>
            );
        }

        planPrice = this.props.plans.current.price;
        if (this.props.plans.current.planTerm == constants.SUBSCRIPTION_TERM_TRIAL) {
            planPrice = 0;
        }

        let pendingChange = null;
        if (this.props.user.detail.postAddons > 0) {
            if (this.props.user.detail.postAddons * 100 !== parseInt(this.props.user.perms.perms.add_on_posts_1)) {
                pendingChange = ". Changes to X Posts will take effect then.";
            }
        }

        if (this.props.user.plan.pauseStart && this.props.user.plan.pauseEnd) {
            let pauseDuration = 'months';
            if (this.props.user.plan.pauseCycles === 1) {
                pauseDuration = 'month';
            }
            renewalBlock = (
                <div className="renewal-notice">
                    (Your plan will pause on {moment(this.props.user.plan.pauseStart).format("MMM D, YYYY")} for {this.props.user.plan.pauseCycles} {pauseDuration} {pendingChange})
                </div>
            );
        } else if (this.props.user.plan.status !== undefined && this.props.user.plan.status.canceled === false) {
            renewalBlock = (
                <div className="renewal-notice">
                    (Your plan renews on {moment(this.props.plans.current.nextBilling).format("MMM D, YYYY")}{pendingChange})
                </div>
            );
        }


        let xPostsButton = (
            <div className="x-posts-button btn-primary reverse-fixed" role="button" onClick={(e) => {
                if (this.props.recordEvent) {
                    this.props.recordEvent({
                        pub_id: this.props.user.detail.id,
                        event_name: 'Click Add Tweets Button',
                        event_data: {
                            source: 'upgrade pricing'
                        }
                    });
                }
                let tweetModal = (
                    <AddTweetModal
                        {...this.props}
                        currentQuantity={this.state.add_on_posts_1}
                        addPosts={this.addPosts}
                        dismissModal={(e) => {
                            this.props.closeAllModals();
                        }}
                        termLabel={termShortLabel}/>
                );
                this.props.addModal(tweetModal);
            }} aria-label="Purchase more X Posts">
                Need more X (Twitter) Posts?
            </div>
        );

        if (this.props.user.plan.status !== undefined && 
            this.props.user.plan.status.canceled === false && 
            !this.props.isBasicUser(this.props.plans.current.planLevel)) {
            addOnBlock = (
                <div className="add-on-block">
                    {xPostsButton}
                    <h3>{"Customize your plan. How many add-ons do you need?"}</h3>
                    {addOnError}
                    <div className="add-on-controls clearfix">
                        <div className="add-on-buttons">
                            <div className="add-on-button increment" data-qty="1" onClick={this.onClickAddOns} role="button" aria-label="+1 add-on">
                                <i className="fa fa-plus"></i>
                            </div>
                            <div className="current-add-on-qty">
                                {this.state.add_on_social}
                            </div>
                            <div className="add-on-button decrement" data-qty="-1" onClick={this.onClickAddOns} role="button" aria-label="-1 add-on">
                                <i className="fa fa-minus"></i>
                            </div>
                        </div>
                        <div className="add-on-display">
                            <div className="add-on-cell">
                                <div className="add-on-qty">
                                    + {limits.addOnOutputs}
                                </div>
                                <div className="add-on-label">
                                    social profiles
                                </div>
                            </div>
                            <div className="add-on-cell">
                                <div className="add-on-qty">
                                    + {limits.addOnInputs}
                                </div>
                                <div className="add-on-label">
                                    feeds & sites
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="add-on-totals">
                        <ul className="plan-sums">
                            <li>
                                <div className="line-item-flex-wrapper">
                                    <div className="line-item">
                                        {'dlvr.it ' + this.props.plans.details[this.props.user.detail.pubLevel].label}
                                    </div>
                                    <div className="line-resource-count">
                                        <span className="resource-total">({currentLimits.baseOutputs} socials + {currentLimits.baseInputs} feeds)</span>
                                    </div>
                                </div>
                                <div className="line-total">
                                    <FormattedNumber value={planPrice} style="currency" currency="USD"/> / {termShortLabel}
                                </div>
                            </li>
                            <li className={this.state.add_on_posts_1 > 0 ? "line-item" : lastTermClass}>
                                <div className="line-item-flex-wrapper">
                                    <div className="line-item">
                                        {this.state.add_on_social} Add-ons
                                    </div>
                                    <div className="line-resource-count">
                                        <span className="resource-total">({limits.addOnOutputs} socials + {limits.addOnInputs} feeds)</span>
                                    </div>
                                </div>
                                <div className="line-total">
                                    <FormattedNumber value={limits.addOnSocialsPrice} style="currency" currency="USD"/> / {termShortLabel}
                                </div>
                            </li>
                            {this.state.add_on_posts_1 > 0 ? (
                                <li className={lastTermClass}>
                                    <div className="line-item-flex-wrapper">
                                        <div className="line-item">
                                            {this.state.add_on_posts_1} X (Twitter) Posts
                                        </div>
                                        <div className="line-resource-count">
                                            <span className="resource-total">({limits.addOnPosts} posts / month)</span>
                                        </div>
                                    </div>
                                    <div className="line-total">
                                        <FormattedNumber value={limits.addOnPostsPrice} style="currency" currency="USD"/> / {termShortLabel}
                                    </div>
                                </li>
                            ) : null }
                            {activeCouponBlock}
                            <li>
                                <div className="line-item-flex-wrapper">
                                    <div className="line-item">
                                        Total
                                    </div>
                                    <div className="line-resource-count">
                                        <span className="resource-total">({limits.outputs} socials + {limits.inputs} feeds)</span>
                                    </div>
                                </div>
                                <div className="line-total">
                                    <FormattedNumber value={limits.price} style="currency" currency="USD"/> / {termShortLabel}
                                </div>
                            </li>
                        </ul>
                        <div className="add-on-button-wrapper">
                            <button className={buttonClass} onClick={buttonAction}>
                                {buttonLabel}
                            </button>
                        </div>
                    </div>
                </div>
            );
        }

        if ((this.props.isBasicUser(this.props.plans.current.planLevel) || this.props.isStarterUser(this.props.plans.current.planLevel)) &&
            (!_.isEmpty(this.props.plans.current) && (this.props.plans.current.status.canceled === false))) {
            addOnBlock = (
                <div>
                    {this.props.isBasicUser(this.props.plans.current.planLevel) ? (
                        <div className="x-posts-block">
                            {xPostsButton}
                        </div>
                     ) : null }
                     <Breakpoint desktop only>
                        <div className="add-on-promo">
                            <div className="promo-content">
                                <div className="promo-headline">
                                    Save time & boost traffic
                                </div>
                                <div className="promo-main">
                                    Go Pro and get premium posting to 10 socials, faster feed updates, and more.
                                </div>
                                <div className="promo-cta">
                                    <div className="btn-primary active upgrade-subscription" role="button" onClick={this.props.promoClick} data-source="promo">
                                        Get Pro Today
                                    </div>
                                </div>
                            </div>
                            <div className="promo-image">
                                <img src={`${imageUrl}/misc/plan-rocket.svg`} width="200" height="auto"/>
                            </div>
                        </div>
                     </Breakpoint>
                     <Breakpoint mobile only>
                        <div className="add-on-promo mobile">
                            <div className="promo-content">
                                <div className="promo-image">
                                    <img src={`${imageUrl}/misc/plan-rocket.svg`} width="200" height="auto"/>
                                </div>
                                <div className="promo-headline">
                                    Save time & boost traffic
                                </div>
                                <div className="promo-main">
                                    Go Pro and get premium posting for 10 socials, faster feed updates, and more.
                                </div>
                                <div className="promo-cta">
                                    <div className="btn-primary active upgrade-subscription" role="button" onClick={this.props.promoClick} data-source="promo">
                                        Get Pro Today
                                    </div>
                                </div>
                            </div>
                        </div>
                     </Breakpoint>
                </div>
            );
        }

        let xtraXeets = null;
        if (currentLimits.addOnPosts > 0) {
            xtraXeets = (
                <div className="resource-usage xeets">
                    {currentLimits.addOnPosts} X Posts - <span className="in-use-label">{this.props.user.perms.resources.extraTweetsRemaining} available</span>
                </div>
            );
        }

        return (
            <div className="current-subscription">
                <div className={headerClass}>
                    <div className="plan-name">
                        Your Plan: {planLabel}
                    </div>
                    <div className="plan-price">
                        {planPriceLabel}
                    </div>
                </div>
                {errorBlock}
                <div className="plan-detail-block">
                    {trialInfo}
                    <div className="resource-usage outputs">
                        {currentLimits.outputs} Social Profiles - <span className="in-use-label">{currentLimits.outputsInUse} in use</span>
                    </div>
                    <div className="resource-usage inputs">
                        {currentLimits.inputs} Feeds and Sites - <span className="in-use-label">{currentLimits.inputsInUse} in use</span>
                    </div>
                    {xtraXeets}
                    {newSubscriptionButton}
                    {annualIncentive}
                    {renewalBlock}
                </div>
                {addOnBlock}
            </div>
        );
    }

};

UpgradePricing.displayName = "UpgradePricing";

UpgradePricing.propTypes = {
    userPerms: PropTypes.object,
    currentSubscription: PropTypes.object,
    planDetails: PropTypes.object,
    onAddOnUpdate: PropTypes.func,
    subscriptionUpdate: PropTypes.func,
    errors: PropTypes.object
};

UpgradePricing.defaultProps = {
    userPerms: {},
    currentSubscription: {},
    planDetails: {},
    onAddOnUpdate: null,
    subscriptionUpdate: null,
    errors: null
};

export default UpgradePricing;
